import {AbstractStripePayment, type ConfirmResult, type TokenResult} from './abstract/class-abstract-stripe-payment';
import {billingDetails} from './stripe';

class StripeAffirmPayment extends AbstractStripePayment {
	public gatewayId() {
		return 'peachpay_stripe_affirm';
	}

	public async tokenize(): Promise<TokenResult> {
		const {paymentMethod, error} = await this.stripe.createPaymentMethod({
			type: 'affirm',
			billing_details: billingDetails(),
		});

		if (error) {
			const message = error.message ?? 'Failed to tokenize payment method.';

			return [null, {
				paymentStatus: 'creationfailed',
				note: message,
			}];
		}

		if (!paymentMethod?.id) {
			return [null, {
				paymentStatus: 'creationfailed',
				note: 'Failed to tokenize payment method.',
			}];
		}

		return [paymentMethod.id, {}];
	}

	public async confirm(clientSecret: string, intermediateURL?: string | undefined): Promise<ConfirmResult> {
		const {paymentIntent, error} = await this.stripe.confirmAffirmPayment(clientSecret, {return_url: intermediateURL});

		if (error) {
			const message = error.message ?? 'Failed to confirm payment.';
			return [null, {
				note: message,
			}];
		}

		if (paymentIntent) {
			return ['success', {}];
		}

		return [null, {}];
	}
}

export {
	StripeAffirmPayment,
};
